<template>
  <div :class="$style.wrapper">
    <div :class="$style.container">
      <SigninForm v-if="mode === 'signin'" :email="email" :oauth-provider="oauthProvider" :is-modal="isModal" :from="from" @toggle="mode = 'signup'" @submit="onSubmit" @close="onClose" />
      <SignupForm
        v-else
        :email="email"
        :member-name="memberName"
        :oauth-provider="oauthProvider"
        :transaction-token="transactionToken"
        :is-modal="isModal"
        :from="from"
        :turnstile-site-key="turnstileSiteKey"
        @toggle="mode = 'signin'"
        @submit="onSubmit"
        @close="onClose"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import SigninForm from './SigninForm.vue';
import SignupForm from './SignupForm.vue';

withDefaults(
  defineProps<{
    email?: string;
    memberName?: string;
    transactionToken?: string;
    oauthProvider?: string;
    isModal?: boolean;
    from?: string;
    turnstileSiteKey: string;
  }>(),
  {
    email: '',
    memberName: '',
    transactionToken: '',
    oauthProvider: undefined,
    from: '',
  },
);
const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'submit'): void;
}>();
const mode = defineModel<'signin' | 'signup'>({ default: 'signup' });
const onSubmit = () => {
  emit('submit');
};
const onClose = () => {
  emit('close');
};
</script>

<style module lang="scss">
.wrapper {
  background-color: var(--color-white);
  margin: 0 auto;
  max-width: 1080px;

  form a {
    text-decoration: underline;
  }
}

.container {
  align-items: center;
  display: flex;
  font-size: 16px;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 30px 20px;
  position: relative;

  @media (--sp) {
    font-size: 14px;
  }

  a {
    &:hover {
      text-decoration: none;
    }
  }
}
</style>
